import 'normalize.css';
import FileArgProvider from './components/FilesArgContext';
import TopSearch from './components/TopSearch';
import Universal from './components/Universal';
import ResultSearch from './components/ResultSearch';
import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import TypeSeries from './components/TypeSeries/index';
import { fetchIndustries, getSeriesCategories } from './services/services';
import './App.css';
import { IntlProvider } from 'react-intl';
import { messages } from './locales'; // 导入包含翻译信息的文件
import { lang } from './config/config';
function App() {
  const [flag, setFlag] = useState(false);
  const [searchArg, setSearchArg] = useState({
    value: '',
    type: 'firmware',
    identify: false,
  });

  const [state, setState] = useState({
    industries: [],
    typeSeries: [],
    selectedIndustry: null,  // 初始化为 null
    openType: null,
    selectedSeries: null,
    loading: true,
    keyword: '',
  });

  const {
    industries,
    typeSeries,
    selectedIndustry,
    openType,
    selectedSeries,
    loading,
    keyword,
  } = state;

  useEffect(() => {
    // 加载行业列表
    fetchIndustries().then(data => {
      const industryMap = {
        EnterpriseNetwork: 0,
        IndustrialDigitalization: 1,
        DigitalEnergy: 2,
        SmartCommerce: 3,
        Mobility: 4,
        CloudServices: 5,
      };
      const res = [];
      data.result.forEach(item => {
        if (industryMap[item.id] !== undefined) {
          res[industryMap[item.id]] = item;
        } else {
          res.push(item);
        }
      });
      setState(prevState => ({ ...prevState, industries: res }));
    });
  }, []);

  useEffect(() => {
    // 加载类型系列列表
    if (industries.length === 0 || !selectedIndustry) return;
    getSeriesCategories(selectedIndustry).then(data => {
      const res = data.result.product_categories.filter(
        item => item.product_series && item.product_series.length > 0
      );
      setState(prevState => ({
        ...prevState,
        typeSeries: res,
        loading: false,
      }));
    });
  }, [industries, selectedIndustry]);

  const generateRoutes = () => {
    // 生成路由
    let routes = [];
    if (typeSeries.length > 0) {
      typeSeries.forEach(type => {
        type.product_series.forEach(series => {
          routes.push(
            <Route
              key={`${type.id}/${series.id}`}
              path={`${type.id}/${series.id}`}
              element={<TypeSeries activeTab={selectedIndustry} />}
            />
          );
        });
      });
    }
    return routes;
  };

  useEffect(() => {

    // 监听 hash 变化并处理路由
    const currentHashname = window.location.hash;
    const pathParts = currentHashname.split('/');
    const currentModel = pathParts[1] || 'EnterpriseNetwork';
    const array = [
      "EnterpriseNetwork",
      "IndustrialDigitalization",
      "DigitalEnergy",
      "SmartCommerce",
      "Mobility",
      "CloudServices",
    ];
    const isarray = array.findIndex(item => item === pathParts[1]);
    if (isarray >= 0) {
      const typeId = pathParts[2];
      const seriesId = pathParts[3];
      localStorage.setItem('one', currentModel);
      localStorage.setItem('two', typeId);
      localStorage.setItem('three', seriesId);
      // if (!typeId && typeSeries.length > 0) {
      //   const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
      //   window.location.href = pathname;
      // } else if (typeId) {
      //   const typeExists = typeSeries.some(type => type.id === typeId);
      //   if (!typeExists && typeSeries.length > 0) {
      //     const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
      //     window.location.href = pathname;
      //   } else {
      //     setState(prevState => ({
      //       ...prevState,
      //       selectedIndustry: currentModel,
      //       openType: typeId,
      //       selectedSeries: seriesId,
      //     }));
      //   }
      // } else if (currentModel === 'EnterpriseNetwork') {
      //   setState(prevState => ({
      //     ...prevState,
      //     selectedIndustry: currentModel,
      //   }));
      // }
    } else {
      const pathname = `#/EnterpriseNetwork/CellularRouter300/IR302`;
      window.location.href = pathname;
    }
  }, [typeSeries]);

  return (
    <IntlProvider
    locale={lang}
    messages={messages[lang]}
  >
    <FileArgProvider>
      <HashRouter>
        <TopSearch
          assignFlag={val => setFlag(val)}
          searchArg={searchArg}
          assignSearchArg={val => setSearchArg(val)}
        />
        {flag && searchArg.value ? (
          <ResultSearch
            searchArg={searchArg}
            assignSearchArg={val => setSearchArg(val)}
          />
        ) : (
          <Universal />
        )}
        <Routes>
          {/* <Route
            path='/'
            element={
              <TypeSeries
                generateRoutes={generateRoutes} // 将生成路由函数传递给组件
              />
            }
          >
            {industries.map(industry => (
              <Route
                key={industry.id}
                path={industry.id}
                element={<Navigate to={industry.id} />}
              >
                {typeSeries.length > 0 && generateRoutes()}
              </Route>
            ))}
          </Route> */}
        </Routes>
      </HashRouter>
    </FileArgProvider>
    </IntlProvider>
  );
}

export default App;
